/* Celebration Jewelers — Ring builder. Setting → Diamond → Your ring. No dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mx-rb]');
  if (!root) return;

  var D = {};
  try { D = JSON.parse(root.querySelector('[data-rb-data]').textContent); } catch (e) { console.error('[ring-builder] bad data', e); return; }

  var SHAPES = ['round', 'oval', 'cushion', 'princess', 'emerald', 'radiant', 'pear', 'marquise', 'heart', 'asscher'];
  var RATIO = { round: 1, oval: 1.4, cushion: 1.08, princess: 1, emerald: 1.4, radiant: 1.25, pear: 1.6, marquise: 2, heart: 1, asscher: 1 };
  var COLOR_HINT = {
    'D': 'Colorless. Icy white and the rarest.',
    'F': 'Near colorless. Looks white face-up, and the best value for most rings.',
    'H': 'Near colorless with a touch of warmth. Lovely in yellow or rose gold.'
  };
  var CLARITY_HINT = {
    'VVS': 'Very, very slightly included. Tiny marks that are hard to find even under magnification.',
    'VS': 'Very slightly included. Clean to the eye, the most popular choice.',
    'SI': 'Slightly included. Often clean to the eye. Ask us to help you choose one.'
  };

  /* ---------- Sample data (preview mode only) -------------------------- */
  if (D.demo) {
    var metals = [['14K White Gold', 1], ['14K Yellow Gold', 1], ['14K Rose Gold', 1], ['18K White Gold', 1.4], ['18K Yellow Gold', 1.4], ['Platinum', 1.75]];
    var demoSettings = [
      ['classic-solitaire', 'The Classic Solitaire', 'Solitaire', 650, 'A slim, rounded band and a four-prong head that lets the diamond do the talking.'],
      ['hidden-halo', 'The Hidden Halo', 'Hidden Halo', 950, 'A solitaire from above, with a secret ring of diamonds tucked under the center stone.'],
      ['halo', 'The Halo', 'Halo', 1150, 'A circle of small diamonds around the center stone for extra size and sparkle.'],
      ['three-stone', 'The Three Stone', 'Three Stone', 1350, 'A center stone flanked by two side diamonds: past, present and future.'],
      ['pave', 'The Pavé', 'Pavé', 850, 'Small diamonds set along the band, catching light from every angle.'],
      ['cathedral', 'The Cathedral', 'Cathedral', 800, 'Graceful shoulders rise to hold the diamond high, like the arches of a cathedral.']
    ];
    var vid = 1;
    D.settings = demoSettings.map(function (s) {
      return { handle: s[0], title: s[1], style: s[2], shapes: '', text: s[4], url: '', images: [], variants: metals.map(function (m) { return { id: 'demo-' + (vid++), metal: m[0], price: Math.round(s[3] * m[1] / 10) * 1000, available: true, image: null }; }) };
    });
    var carats = ['0.50', '0.75', '1.00', '1.25', '1.50', '1.75', '2.00', '2.50', '3.00'];
    var labBase = [350, 500, 700, 900, 1150, 1400, 1700, 2400, 3200];
    var natBase = [1600, 2800, 5200, 7000, 10500, 13500, 19000, 28000, 42000];
    var grid = function (base, cm, km) {
      var v = [];
      carats.forEach(function (c, i) {
        [['D–E', cm[0]], ['F–G', 1], ['H–I', cm[1]]].forEach(function (co) {
          [['VVS', km[0]], ['VS', 1], ['SI', km[1]]].forEach(function (cl) {
            v.push({ id: 'demo-' + (vid++), carat: c, color: co[0], clarity: cl[0], price: Math.round(base[i] * co[1] * cl[1] / 10) * 1000, available: true });
          });
        });
      });
      return { handle: 'demo', title: 'Center diamond', image: null, variants: v };
    };
    D.grids = { lab: grid(labBase, [1.15, 0.85], [1.15, 0.82]), natural: grid(natBase, [1.35, 0.75], [1.3, 0.75]) };
    D.stock = D.stock || [];
  }

  var settings = D.settings || [];
  var grids = D.grids || {};
  var stock = (D.stock || []).filter(function (s) { return s.available; });
  var origins = ['lab', 'natural'].filter(function (o) { return grids[o] && grids[o].variants && grids[o].variants.length; });

  /* ---------- Helpers ---------------------------------------------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var fmtMoney = (function () {
    var f;
    try { f = new Intl.NumberFormat('en-US', { style: 'currency', currency: D.currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }); } catch (e) {}
    return function (cents) { var n = (cents || 0) / 100; return f ? f.format(n) : '$' + n.toFixed(2); };
  })();
  function uniq(arr) { var o = []; arr.forEach(function (x) { if (x != null && x !== '' && o.indexOf(x) < 0) o.push(x); }); return o; }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }
  function metalTone(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('rose') > -1) return 'rose';
    if (n.indexOf('platinum') > -1) return 'platinum';
    if (n.indexOf('white') > -1) return 'white';
    return 'yellow';
  }
  function caratNum(c) { return parseFloat(String(c).replace(/[^\d.]/g, '')) || 1; }
  function caratLabel(c) { return caratNum(c).toFixed(2) + ' ct'; }
  function mm(shape, carat) {
    var d = 6.5 * Math.cbrt(caratNum(carat));
    var r = RATIO[shape] || 1;
    if (r === 1) return shape === 'round' ? d.toFixed(1) + ' mm' : (d * 0.9).toFixed(1) + ' × ' + (d * 0.9).toFixed(1) + ' mm';
    var w = d / Math.sqrt(r) * 1.02;
    return (w * r).toFixed(1) + ' × ' + w.toFixed(1) + ' mm';
  }
  function hintFor(map, value) {
    var k = Object.keys(map).filter(function (x) { return String(value).toUpperCase().indexOf(x) === 0; })[0];
    return k ? map[k] : '';
  }
  function originLabel(o) { return o === 'natural' ? 'Natural' : 'Lab-grown'; }
  function metalsOf(s) { return uniq(s.variants.map(function (v) { return v.metal; })); }
  var allMetals = uniq([].concat.apply([], settings.map(metalsOf)));
  var allStyles = uniq(settings.map(function (s) { return s.style; }));

  /* ---------- State ------------------------------------------------------ */
  var S = { step: 'setting', style: 'all', metal: allMetals[0] || '', setting: null, origin: origins[0] || 'lab', shape: 'round', carat: null, color: null, clarity: null, stock: null, diamondChosen: false, tab: 'spec', size: '', engraving: '' };

  (function load() {
    var q = new URLSearchParams(location.search);
    if (q.get('s')) S.setting = q.get('s');
    if (q.get('m')) S.metal = q.get('m');
    if (q.get('o') && origins.indexOf(q.get('o')) > -1) S.origin = q.get('o');
    var sh = q.get('sh') || q.get('shape');
    if (sh && SHAPES.indexOf(sh.toLowerCase()) > -1) S.shape = sh.toLowerCase();
    if (q.get('ct')) S.carat = q.get('ct');
    if (q.get('co')) S.color = q.get('co');
    if (q.get('cl')) S.clarity = q.get('cl');
    if (q.get('st')) { S.stock = q.get('st'); S.tab = 'stock'; }
    if (q.get('dc') === '1' || S.stock) S.diamondChosen = true;
    if (q.get('style')) S.style = q.get('style');
    if (!settingByHandle(S.setting)) S.setting = null;
    if (allMetals.indexOf(S.metal) < 0) S.metal = allMetals[0] || '';
    fixDiamond();
  })();

  function save() {
    var q = new URLSearchParams(location.search);
    ['s', 'm', 'o', 'sh', 'shape', 'ct', 'co', 'cl', 'st', 'dc', 'style', 'contact_posted'].forEach(function (k) { q.delete(k); });
    if (S.setting) q.set('s', S.setting);
    if (S.metal) q.set('m', S.metal);
    q.set('o', S.origin);
    q.set('sh', S.shape);
    if (S.carat) q.set('ct', S.carat);
    if (S.color) q.set('co', S.color);
    if (S.clarity) q.set('cl', S.clarity);
    if (S.stock) q.set('st', S.stock);
    if (S.diamondChosen) q.set('dc', '1');
    try { history.replaceState(null, '', location.pathname + '?' + q.toString() + '#/' + S.step); } catch (e) {}
  }

  function settingByHandle(h) { for (var i = 0; i < settings.length; i++) if (settings[i].handle === h) return settings[i]; return null; }
  function settingVariant(s, metal) {
    if (!s) return null;
    var v = s.variants.filter(function (x) { return x.metal === metal; })[0];
    return v || s.variants[0];
  }
  function allowedShapes() {
    var s = settingByHandle(S.setting);
    if (!s || !s.shapes) return SHAPES;
    var list = s.shapes.split(',').map(function (x) { return x.trim(); }).filter(function (x) { return SHAPES.indexOf(x) > -1; });
    return list.length ? list : SHAPES;
  }
  function gridValues(key) {
    var g = grids[S.origin];
    if (!g) return [];
    var vals = uniq(g.variants.map(function (v) { return v[key]; }));
    if (key === 'carat') vals.sort(function (a, b) { return caratNum(a) - caratNum(b); });
    return vals;
  }
  function fixDiamond() {
    var c = gridValues('carat'), co = gridValues('color'), cl = gridValues('clarity');
    if (c.indexOf(S.carat) < 0) S.carat = c.filter(function (x) { return caratNum(x) === 1; })[0] || c[Math.floor(c.length / 3)] || null;
    if (co.indexOf(S.color) < 0) S.color = co[1] || co[0] || null;
    if (cl.indexOf(S.clarity) < 0) S.clarity = cl.filter(function (x) { return /^VS/i.test(x) && !/^VVS/i.test(x); })[0] || cl[0] || null;
    if (allowedShapes().indexOf(S.shape) < 0) S.shape = allowedShapes()[0];
  }
  function gridVariant(carat) {
    var g = grids[S.origin];
    if (!g) return null;
    return g.variants.filter(function (v) { return v.carat === (carat || S.carat) && v.color === S.color && v.clarity === S.clarity; })[0] || null;
  }
  function stockById(id) { return stock.filter(function (s) { return String(s.id) === String(id); })[0] || null; }

  /* The chosen center stone, normalised. */
  function diamond() {
    if (S.stock) {
      var st = stockById(S.stock);
      if (st) return { id: st.id, price: st.price, shape: st.shape || 'round', carat: st.carat, color: st.color, clarity: st.clarity, origin: st.origin || '', cert: st.cert, certUrl: st.certUrl, title: st.title, stock: true, image: st.image };
    }
    var v = gridVariant();
    if (!v) return null;
    return { id: v.id, price: v.price, shape: S.shape, carat: v.carat, color: v.color, clarity: v.clarity, origin: S.origin, stock: false, available: v.available };
  }
  function diamondLine(d) {
    if (!d) return '';
    return caratLabel(d.carat) + ' ' + cap(d.shape) + (d.origin ? ' ' + originLabel(d.origin).toLowerCase() : '') + ' · ' + d.color + ' · ' + d.clarity;
  }

  /* ---------- The drawing ----------------------------------------------- */
  var SHAPE_PATH = {
    round: '<circle cx="20" cy="20" r="15"/>',
    oval: '<ellipse cx="20" cy="20" rx="11" ry="16"/>',
    cushion: '<rect x="6" y="6" width="28" height="28" rx="8"/>',
    princess: '<rect x="6" y="6" width="28" height="28"/>',
    emerald: '<path d="M13 4h14l5 5v22l-5 5H13l-5-5V9z"/>',
    radiant: '<path d="M12 4h16l5 5v22l-5 5H12l-5-5V9z"/>',
    pear: '<path d="M20 4c5 7 12 13.5 12 21a12 12 0 0 1-24 0C8 17.5 15 11 20 4z"/>',
    marquise: '<path d="M20 3c7.5 6 11 11.5 11 17s-3.5 11-11 17C12.5 31 9 25.5 9 20S12.5 9 20 3z"/>',
    heart: '<path d="M20 34S5 24.5 5 14.5A7.5 7.5 0 0 1 20 11a7.5 7.5 0 0 1 15 3.5C35 24.5 20 34 20 34z"/>',
    asscher: '<path d="M13 5h14l8 8v14l-8 8H13l-8-8V13z"/>'
  };
  var FACETS = {
    round: '<path d="M20 5l5.5 9.5L35 20l-9.5 5.5L20 35l-5.5-9.5L5 20l9.5-5.5z M14.5 14.5h11v11h-11z"/>',
    oval: '<path d="M20 4l5 9 6 7-6 7-5 9-5-9-6-7 6-7z"/>',
    cushion: '<path d="M12 12h16v16H12z M6.5 9.5 12 12M33.5 9.5 28 12M6.5 30.5 12 28M33.5 30.5 28 28"/>',
    princess: '<path d="M6 6l28 28M34 6 6 34M20 6v28M6 20h28"/>',
    emerald: '<path d="M15.5 9h9l2.5 2.5v17L24.5 31h-9L13 28.5v-17z M18 13h4v14h-4z"/>',
    radiant: '<path d="M12 4l8 16 8-16M12 36l8-16 8 16M7 9l13 11L7 31M33 9 20 20l13 11"/>',
    pear: '<path d="M20 4l-4 15 4 18 4-18z M8.5 23l7.5-4M31.5 23 24 19"/>',
    marquise: '<path d="M20 3v34M9 20h22M20 3l-5 17 5 17 5-17z"/>',
    heart: '<path d="M20 11v23M12 14l8 8 8-8"/>',
    asscher: '<path d="M15.5 10h9l5.5 5.5v9L24.5 30h-9L10 24.5v-9z M18 15h4l3 3v4l-3 3h-4l-3-3v-4z"/>'
  };
  var FACE = { round: [30, 30], oval: [22, 32], cushion: [28, 28], princess: [28, 28], emerald: [24, 32], radiant: [26, 32], pear: [24, 33], marquise: [22, 34], heart: [30, 27], asscher: [30, 30] };
  var TONES = {
    yellow: ['#f6e3a8', '#d9b25c', '#a9802f'],
    rose: ['#f7d4c2', '#dda184', '#a8674c'],
    white: ['#f4f5f6', '#cfd3d8', '#8f959c'],
    platinum: ['#f1f2f3', '#c4c8cc', '#878c92']
  };
  var uid = 0;
  function stoneSVG(shape, cx, cy, size, id, squash) {
    var s = size / 40;
    return '<g transform="translate(' + (cx - size / 2) + ' ' + (cy - size / 2 * (squash || 1)) + ') scale(' + s + ' ' + (s * (squash || 1)) + ')">' +
      '<g fill="url(#' + id + 'st)" stroke="#8e979f" stroke-width="' + (1 / s).toFixed(2) + '">' + SHAPE_PATH[shape] + '</g>' +
      '<g fill="none" stroke="#aeb7bf" stroke-width="' + (0.7 / s).toFixed(2) + '" opacity=".9">' + FACETS[shape] + '</g></g>';
  }
  function ringSVG(opts) {
    var id = 'rb' + (++uid);
    var tone = TONES[metalTone(opts.metal)];
    var style = (opts.style || '').toLowerCase();
    var shape = opts.shape || 'round';
    var r = RATIO[shape] || 1;
    var size = 78 * Math.cbrt(caratNum(opts.carat || 1));       // stone length on its long axis
    var wl = FACE[shape] || [30, 30];
    var sw = size * wl[0] / 40, sl = size * wl[1] / 40;            // the stone's real face width / length
    var cx = 200, bandCy = 238, brx = 96, bry = 92;               // the band, standing upright
    var cy = bandCy - bry - sl * 0.2;                             // stone centre, seated on the head
    var halo = style.indexOf('halo') > -1 && style.indexOf('hidden') < 0;
    var hidden = style.indexOf('hidden') > -1;
    var pave = style.indexOf('pav') > -1 || halo;
    var three = style.indexOf('three') > -1;
    var cath = style.indexOf('cathedral') > -1;
    var dot = function (x, y, rr) { return '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + rr + '" fill="url(#' + id + 'st)" stroke="' + tone[2] + '" stroke-width=".8"/>'; };
    var P = [];
    P.push('<defs>' +
      '<linearGradient id="' + id + 'm" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + tone[0] + '"/><stop offset=".45" stop-color="' + tone[1] + '"/><stop offset="1" stop-color="' + tone[2] + '"/></linearGradient>' +
      '<linearGradient id="' + id + 'mi" x1="1" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + tone[2] + '"/><stop offset=".6" stop-color="' + tone[1] + '"/><stop offset="1" stop-color="' + tone[0] + '"/></linearGradient>' +
      '<radialGradient id="' + id + 'st" cx=".38" cy=".32" r=".85"><stop offset="0" stop-color="#ffffff"/><stop offset=".55" stop-color="#eef2f5"/><stop offset="1" stop-color="#cfd7de"/></radialGradient>' +
      '<radialGradient id="' + id + 'sh" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#1a1611" stop-opacity=".16"/><stop offset="1" stop-color="#1a1611" stop-opacity="0"/></radialGradient>' +
      '</defs>');
    // soft floor shadow
    P.push('<ellipse cx="' + cx + '" cy="' + (bandCy + bry + 14) + '" rx="' + (brx + 30) + '" ry="12" fill="url(#' + id + 'sh)"/>');
    // band: outer face, inner face, highlight
    P.push('<ellipse cx="' + cx + '" cy="' + bandCy + '" rx="' + brx + '" ry="' + bry + '" fill="none" stroke="url(#' + id + 'm)" stroke-width="15"/>');
    P.push('<ellipse cx="' + cx + '" cy="' + bandCy + '" rx="' + (brx - 7) + '" ry="' + (bry - 7) + '" fill="none" stroke="url(#' + id + 'mi)" stroke-width="2.2" opacity=".9"/>');
    P.push('<path d="M' + (cx - brx + 4) + ' ' + (bandCy + 10) + ' A ' + (brx - 4) + ' ' + (bry - 4) + ' 0 0 0 ' + (cx + brx - 30) + ' ' + (bandCy + bry - 30) + '" fill="none" stroke="#fff" stroke-opacity=".55" stroke-width="1.6"/>');
    // pavé along the upper shoulders
    if (pave) {
      for (var i = 0; i < 9; i++) {
        var a = Math.PI * (0.62 + i * 0.045);
        P.push(dot(cx + brx * Math.cos(a), bandCy - bry * Math.sin(a), 3));
        P.push(dot(cx - brx * Math.cos(a), bandCy - bry * Math.sin(a), 3));
      }
    }
    // cathedral shoulders
    if (cath) {
      P.push('<path d="M' + (cx - 62) + ' ' + (bandCy - bry + 22) + ' Q ' + (cx - 30) + ' ' + (cy + sl * 0.28) + ' ' + (cx - sw * 0.28) + ' ' + (cy + sl * 0.36) + ' M' + (cx + 62) + ' ' + (bandCy - bry + 22) + ' Q ' + (cx + 30) + ' ' + (cy + sl * 0.28) + ' ' + (cx + sw * 0.28) + ' ' + (cy + sl * 0.36) + '" fill="none" stroke="url(#' + id + 'm)" stroke-width="8" stroke-linecap="round"/>');
    }
    // head / basket
    P.push('<path d="M' + (cx - sw * 0.3) + ' ' + (cy + sl * 0.3) + ' L ' + (cx - 9) + ' ' + (bandCy - bry + 2) + ' L ' + (cx + 9) + ' ' + (bandCy - bry + 2) + ' L ' + (cx + sw * 0.3) + ' ' + (cy + sl * 0.3) + '" fill="url(#' + id + 'm)" stroke="' + tone[2] + '" stroke-width=".8" stroke-linejoin="round"/>');
    if (hidden) for (var hh = -3; hh <= 3; hh++) P.push(dot(cx + hh * 6.6, cy + sl * 0.36 + Math.abs(hh) * 0.6, 2.8));
    // side stones
    if (three) {
      var side = size * 0.56, sideShape = shape === 'round' || shape === 'oval' || shape === 'cushion' ? 'round' : shape === 'pear' || shape === 'marquise' || shape === 'heart' ? 'pear' : 'princess';
      P.push(stoneSVG(sideShape, cx - sw / 2 - side / 2 + 2, cy + sl * 0.18, side, id, 1));
      P.push(stoneSVG(sideShape, cx + sw / 2 + side / 2 - 2, cy + sl * 0.18, side, id, 1));
    }
    // halo
    if (halo) {
      var n = Math.max(14, Math.round((sw + sl) * 0.42));
      for (var k = 0; k < n; k++) {
        var t = 2 * Math.PI * k / n;
        P.push(dot(cx + (sw / 2 + 6) * Math.cos(t), cy + (sl / 2 + 6) * Math.sin(t), 3.4));
      }
    }
    // the center stone, face on
    P.push(stoneSVG(shape, cx, cy, size, id, 1));
    // prongs
    var pts = shape === 'princess' || shape === 'asscher' ? [[-0.47, -0.47], [0.47, -0.47], [-0.47, 0.47], [0.47, 0.47]]
      : shape === 'emerald' || shape === 'radiant' ? [[-0.42, -0.44], [0.42, -0.44], [-0.42, 0.44], [0.42, 0.44]]
      : shape === 'cushion' ? [[-0.4, -0.4], [0.4, -0.4], [-0.4, 0.4], [0.4, 0.4]]
      : shape === 'pear' ? [[0, -0.47], [-0.42, 0.22], [0.42, 0.22]]
      : shape === 'marquise' ? [[0, -0.48], [0, 0.48]]
      : shape === 'heart' ? [[0, 0.46], [-0.44, -0.18], [0.44, -0.18]]
      : [[-0.36, -0.36], [0.36, -0.36], [-0.36, 0.36], [0.36, 0.36]];
    pts.forEach(function (p) {
      P.push('<circle cx="' + (cx + p[0] * sw).toFixed(1) + '" cy="' + (cy + p[1] * sl).toFixed(1) + '" r="3.4" fill="url(#' + id + 'm)" stroke="' + tone[2] + '" stroke-width=".6"/>');
    });
    return '<svg class="mx-rb-ring" viewBox="60 20 280 345" role="img" aria-label="' + esc(opts.label || 'Ring preview') + '">' + P.join('') + '</svg>';
  }
  function shapeIcon(shape) { return '<svg viewBox="0 0 40 40" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true">' + SHAPE_PATH[shape] + '<g opacity=".5">' + FACETS[shape] + '</g></svg>'; }
  function swatch(metal) { return '<span class="mx-rb-sw mx-rb-sw--' + metalTone(metal) + '" aria-hidden="true"></span>'; }
  function karat(metal) { var m = /(\d+)\s*k/i.exec(metal || ''); return m ? m[1] + 'K' : /platinum/i.test(metal) ? 'PT' : ''; }

  /* ---------- Views ------------------------------------------------------ */
  var view = root.querySelector('[data-rb-view]');
  var summary = root.querySelector('[data-rb-summary]');
  var bar = root.querySelector('[data-rb-bar]');

  function settingCard(s) {
    var v = settingVariant(s, S.metal);
    var img = (v && v.image) || s.images[0];
    var chosen = S.setting === s.handle;
    var media = img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="600" height="600">' : ringSVG({ metal: v && v.metal, shape: S.shape, style: s.style, carat: 1, label: s.title });
    return '<article class="mx-rb-card' + (chosen ? ' is-chosen' : '') + '">' +
      '<button class="mx-rb-card__hit" type="button" data-act="detail" data-h="' + esc(s.handle) + '" aria-label="Details for ' + esc(s.title) + '"></button>' +
      '<div class="mx-rb-card__media">' + media + (chosen ? '<span class="mx-rb-card__tick">Selected</span>' : '') + '</div>' +
      '<div class="mx-rb-card__body"><span class="mx-rb-card__style">' + esc(s.style) + '</span>' +
      '<h3 class="mx-rb-card__title">' + esc(s.title) + '</h3>' +
      '<span class="mx-rb-card__price">' + fmtMoney(v ? v.price : 0) + ' <small>setting · ' + esc(v ? v.metal : '') + '</small></span>' +
      '<span class="mx-rb-card__sws">' + metalsOf(s).map(swatch).join('') + '</span></div>' +
      '<div class="mx-rb-card__acts"><button class="mx-btn mx-btn--sm' + (chosen ? ' mx-btn--gold' : '') + '" type="button" data-act="choose-setting" data-h="' + esc(s.handle) + '">' + (chosen ? 'Selected' : 'Choose') + '</button>' +
      '<button class="mx-link" type="button" data-act="detail" data-h="' + esc(s.handle) + '">Details</button></div></article>';
  }

  function renderSetting() {
    var list = settings.filter(function (s) { return S.style === 'all' || s.style === S.style; });
    var h = '<div class="mx-rb-head"><span class="mx-kicker">Step I</span><h2 class="mx-h2">Choose your <em>setting</em></h2></div>';
    h += '<div class="mx-rb-tools">';
    if (allStyles.length > 1) {
      h += '<div class="mx-rb-chips" role="group" aria-label="Style">' + ['all'].concat(allStyles).map(function (st) {
        return '<button class="mx-chip" type="button" data-act="style" data-v="' + esc(st) + '" aria-pressed="' + (S.style === st) + '">' + (st === 'all' ? 'All styles' : esc(st)) + '</button>';
      }).join('') + '</div>';
    }
    if (allMetals.length > 1) {
      h += '<div class="mx-rb-metals" role="group" aria-label="Metal"><span class="mx-label">Metal</span>' + allMetals.map(function (m) {
        return '<button class="mx-rb-metal" type="button" data-act="metal" data-v="' + esc(m) + '" aria-pressed="' + (S.metal === m) + '" title="' + esc(m) + '">' + swatch(m) + '<span>' + esc(karat(m)) + '</span><span class="mx-sr">' + esc(m) + '</span></button>';
      }).join('') + '<span class="mx-rb-metal__name">' + esc(S.metal) + '</span></div>';
    }
    h += '</div>';
    h += list.length ? '<div class="mx-rb-grid">' + list.map(settingCard).join('') + '</div>' : '<p class="mx-alert">No settings in this style yet. <button class="mx-link" type="button" data-act="style" data-v="all">Show all styles</button></p>';
    view.innerHTML = h;
  }

  function pills(key, values, label, hintMap) {
    var cur = S[key];
    var h = '<fieldset class="mx-rb-field"><legend class="mx-label">' + label + (cur ? ' <span class="mx-rb-field__val">' + esc(key === 'carat' ? caratLabel(cur) : cur) + '</span>' : '') + '</legend><div class="mx-rb-pills">';
    h += values.map(function (v) {
      return '<button class="mx-rb-pill" type="button" data-act="spec" data-k="' + key + '" data-v="' + esc(v) + '" aria-pressed="' + (cur === v) + '">' + esc(key === 'carat' ? caratNum(v).toFixed(2) : v) + '</button>';
    }).join('');
    h += '</div>';
    if (hintMap && cur) h += '<p class="mx-rb-hint">' + esc(hintFor(hintMap, cur)) + '</p>';
    return h + '</fieldset>';
  }

  function renderDiamond() {
    var h = '<div class="mx-rb-head"><span class="mx-kicker">Step II</span><h2 class="mx-h2">Choose your <em>diamond</em></h2></div>';
    if (stock.length) {
      h += '<div class="mx-rb-tabs" role="tablist"><button class="mx-tab" role="tab" type="button" data-act="tab" data-v="spec" aria-selected="' + (S.tab === 'spec') + '">Build to your specs</button>' +
        '<button class="mx-tab" role="tab" type="button" data-act="tab" data-v="stock" aria-selected="' + (S.tab === 'stock') + '">In our case <span class="mx-num">(' + stock.length + ')</span></button></div>';
    }
    if (S.tab === 'stock' && stock.length) { view.innerHTML = h + renderStock(); return; }
    if (!origins.length) { view.innerHTML = h + '<p class="mx-alert">Diamond prices aren’t set up yet. Call us at ' + esc(D.text.phone) + ' and we’ll quote you.</p>'; return; }

    h += '<div class="mx-rb-diamond">';
    h += '<div class="mx-rb-diamond__opts">';
    if (origins.length > 1) {
      h += '<fieldset class="mx-rb-field"><legend class="mx-label">Diamond</legend><div class="mx-rb-seg">' + origins.map(function (o) {
        return '<button type="button" data-act="origin" data-v="' + o + '" aria-pressed="' + (S.origin === o) + '">' + originLabel(o) + '</button>';
      }).join('') + '</div><p class="mx-rb-hint">' + (S.origin === 'lab' ? 'Real diamond, grown in a lab. Same sparkle and hardness, a fraction of the price.' : 'Formed in the earth over millions of years. Graded on the same scale as lab-grown.') + '</p></fieldset>';
    }
    var allowed = allowedShapes();
    h += '<fieldset class="mx-rb-field"><legend class="mx-label">Shape <span class="mx-rb-field__val">' + cap(S.shape) + '</span></legend><div class="mx-rb-shapes">' + SHAPES.map(function (sh) {
      var ok = allowed.indexOf(sh) > -1;
      return '<button class="mx-rb-shape" type="button" data-act="shape" data-v="' + sh + '" aria-pressed="' + (S.shape === sh) + '"' + (ok ? '' : ' disabled title="This setting doesn’t take a ' + sh + ' diamond"') + '>' + shapeIcon(sh) + '<span>' + cap(sh) + '</span></button>';
    }).join('') + '</div></fieldset>';
    h += pills('carat', gridValues('carat'), 'Carat');
    h += pills('color', gridValues('color'), 'Color', COLOR_HINT);
    h += pills('clarity', gridValues('clarity'), 'Clarity', CLARITY_HINT);
    h += '</div>';

    var d = diamond();
    h += '<div class="mx-rb-stone">';
    h += '<div class="mx-rb-stone__art">' + '<svg viewBox="0 0 200 200" aria-hidden="true"><defs><radialGradient id="rbstone" cx=".4" cy=".35" r=".8"><stop offset="0" stop-color="#fff"/><stop offset=".6" stop-color="#eef2f5"/><stop offset="1" stop-color="#d6dde3"/></radialGradient></defs>' +
      (function () { var sz = 70 * Math.cbrt(caratNum(S.carat)); var s = sz / 40; return '<g transform="translate(' + (100 - sz / 2) + ' ' + (100 - sz / 2) + ') scale(' + s + ')"><g fill="url(#rbstone)" stroke="#9aa3ab" stroke-width="' + (0.8 / s).toFixed(2) + '">' + SHAPE_PATH[S.shape] + '</g><g fill="none" stroke="#b9c1c8" stroke-width="' + (0.5 / s).toFixed(2) + '">' + FACETS[S.shape] + '</g></g>'; })() +
      '</svg><span class="mx-rb-stone__mm">≈ ' + mm(S.shape, S.carat) + '</span></div>';
    if (d) {
      h += '<div class="mx-rb-stone__info"><span class="mx-kicker">' + originLabel(S.origin) + ' diamond</span>' +
        '<h3 class="mx-h3">' + caratLabel(d.carat) + ' ' + cap(S.shape) + '</h3>' +
        '<dl class="mx-rb-dl"><div><dt>Color</dt><dd>' + esc(d.color) + '</dd></div><div><dt>Clarity</dt><dd>' + esc(d.clarity) + '</dd></div><div><dt>Size</dt><dd>≈ ' + mm(S.shape, d.carat) + '</dd></div></dl>' +
        '<p class="mx-rb-stone__price mx-num">' + fmtMoney(d.price) + '</p>' +
        '<button class="mx-btn mx-btn--block' + (S.diamondChosen && !S.stock ? ' mx-btn--gold' : '') + '" type="button" data-act="choose-diamond">' + (S.diamondChosen && !S.stock ? 'Selected · Review your ring' : 'Choose this diamond') + '</button>' +
        '<p class="mx-rb-hint">' + esc(D.text.sourcing) + '</p></div>';
    } else {
      h += '<p class="mx-alert">That combination isn’t available. Try a different color or clarity.</p>';
    }
    h += '</div>';

    // other sizes at this color and clarity
    var rows = gridValues('carat').map(function (c) { return { c: c, v: gridVariant(c) }; }).filter(function (r) { return r.v; });
    if (rows.length > 1) {
      h += '<div class="mx-rb-table-wrap"><h3 class="mx-label" style="margin-bottom:10px">Compare sizes · ' + esc(cap(S.shape) + ' · ' + S.color + ' · ' + S.clarity) + '</h3><table class="mx-rb-table"><thead><tr><th>Carat</th><th>Approx. size</th><th>Price</th><th><span class="mx-sr">Choose</span></th></tr></thead><tbody>' +
        rows.map(function (r) {
          var on = r.c === S.carat;
          return '<tr' + (on ? ' class="is-on"' : '') + '><td>' + caratLabel(r.c) + '</td><td>' + mm(S.shape, r.c) + '</td><td class="mx-num">' + fmtMoney(r.v.price) + '</td><td><button class="mx-link" type="button" data-act="spec" data-k="carat" data-v="' + esc(r.c) + '">' + (on ? 'Viewing' : 'View') + '</button></td></tr>';
        }).join('') + '</tbody></table></div>';
    }
    h += '</div>';
    view.innerHTML = h;
  }

  function renderStock() {
    var h = '<p class="mx-rb-hint" style="margin-bottom:18px">Loose diamonds we have in the store right now, each with its own report.</p><div class="mx-rb-table-wrap"><table class="mx-rb-table mx-rb-table--stock"><thead><tr><th>Shape</th><th>Carat</th><th>Color</th><th>Clarity</th><th>Report</th><th>Price</th><th><span class="mx-sr">Choose</span></th></tr></thead><tbody>';
    h += stock.map(function (s) {
      var on = String(S.stock) === String(s.id);
      var sh = SHAPES.indexOf(s.shape) > -1 ? s.shape : 'round';
      return '<tr' + (on ? ' class="is-on"' : '') + '><td><span class="mx-rb-table__shape">' + shapeIcon(sh) + cap(sh) + '</span></td><td>' + (s.carat ? caratLabel(s.carat) : '—') + '</td><td>' + esc(s.color || '—') + '</td><td>' + esc(s.clarity || '—') + '</td><td>' +
        (s.certUrl ? '<a href="' + esc(s.certUrl) + '" target="_blank" rel="noopener">' + esc(s.cert || 'View') + '</a>' : esc(s.cert || '—')) + '</td><td class="mx-num">' + fmtMoney(s.price) + '</td><td><button class="mx-btn mx-btn--sm' + (on ? ' mx-btn--gold' : '') + '" type="button" data-act="choose-stock" data-v="' + esc(s.id) + '">' + (on ? 'Selected' : 'Choose') + '</button></td></tr>';
    }).join('');
    return h + '</tbody></table></div>';
  }

  function sizes() {
    var o = [];
    for (var s = 3; s <= 10.001; s += 0.25) o.push(String(+s.toFixed(2)));
    return o;
  }

  function renderReview() {
    var s = settingByHandle(S.setting), v = settingVariant(s, S.metal), d = S.diamondChosen ? diamond() : null;
    var h = '<div class="mx-rb-head"><span class="mx-kicker">Step III</span><h2 class="mx-h2">Your <em>ring</em></h2></div>';
    if (!s || !d) {
      h += '<div class="mx-rb-empty"><p class="mx-lede">' + (!s ? 'Start by choosing a setting.' : 'Now choose the diamond for your ' + esc(s.title) + '.') + '</p>' +
        '<a class="mx-btn" href="#/' + (!s ? 'setting' : 'diamond') + '">' + (!s ? 'Choose a setting' : 'Choose a diamond') + '</a></div>';
      view.innerHTML = h; return;
    }
    var total = (v ? v.price : 0) + d.price;
    var imgs = ((v && v.image) ? [v.image] : []).concat(s.images.filter(function (i) { return !v || i !== v.image; })).slice(0, 4);
    h += '<div class="mx-rb-review">';
    h += '<div class="mx-rb-review__stage"><div class="mx-rb-review__art">' + ringSVG({ metal: v.metal, shape: d.shape, style: s.style, carat: d.carat, label: s.title + ' with a ' + diamondLine(d) }) + '<span class="mx-rb-review__cap">Illustration · ' + esc(v.metal) + '</span></div>' +
      (imgs.length ? '<div class="mx-rb-review__thumbs">' + imgs.map(function (i) { return '<img src="' + esc(i) + '" alt="" loading="lazy" width="300" height="300">'; }).join('') + '</div>' : '') + '</div>';
    h += '<div class="mx-rb-review__spec">';
    h += '<div class="mx-rb-line"><div><span class="mx-label">Setting</span><p class="mx-rb-line__t">' + esc(s.title) + '</p><p class="mx-muted mx-small">' + esc(s.style) + ' · ' + esc(v.metal) + '</p></div><div class="mx-rb-line__r"><span class="mx-num">' + fmtMoney(v.price) + '</span><a class="mx-rb-change" href="#/setting">Change</a></div></div>';
    h += '<div class="mx-rb-line"><div><span class="mx-label">Center diamond</span><p class="mx-rb-line__t">' + caratLabel(d.carat) + ' ' + cap(d.shape) + '</p><p class="mx-muted mx-small">' + (d.origin ? originLabel(d.origin) + ' · ' : '') + esc(d.color) + ' color · ' + esc(d.clarity) + ' clarity · ≈ ' + mm(d.shape, d.carat) + (d.stock && d.cert ? ' · ' + esc(d.cert) : '') + '</p></div><div class="mx-rb-line__r"><span class="mx-num">' + fmtMoney(d.price) + '</span><a class="mx-rb-change" href="#/diamond">Change</a></div></div>';
    h += '<div class="mx-rb-form">';
    h += '<div class="mx-field"><label class="mx-label" for="rb-size">Ring size</label><select class="mx-select" id="rb-size" data-act="size" required><option value="">Choose a size</option>' +
      sizes().map(function (z) { return '<option value="' + z + '"' + (S.size === z ? ' selected' : '') + '>' + z + '</option>'; }).join('') +
      '<option value="To be sized in store"' + (S.size === 'To be sized in store' ? ' selected' : '') + '>Not sure — I’ll be sized in the store</option></select></div>';
    if (D.engraving) h += '<div class="mx-field"><label class="mx-label" for="rb-eng">Engraving <span class="mx-muted" style="text-transform:none;letter-spacing:0">(optional, up to 20 characters)</span></label><input class="mx-input" id="rb-eng" maxlength="20" value="' + esc(S.engraving) + '" data-act="engraving" placeholder="e.g. Always · 06.14.27"></div>';
    h += '</div>';
    h += '<div class="mx-rb-total"><span>Total</span><span class="mx-num">' + fmtMoney(total) + '</span></div>';
    h += '<p class="mx-rb-err" data-rb-err role="alert"></p>';
    if (D.demo) {
      h += '<button class="mx-btn mx-btn--block" type="button" data-act="ask">Send this design to the store</button><p class="mx-rb-hint">We’ll reply with exact stones and a quote. Prices shown are a guide.</p>';
    } else {
      h += '<button class="mx-btn mx-btn--block" type="button" data-act="add">Add ring to bag · ' + fmtMoney(total) + '</button>';
      h += '<button class="mx-btn mx-btn--line mx-btn--block" type="button" data-act="ask" style="margin-top:10px">Ask us about this ring</button>';
    }
    h += '<div class="mx-rb-review__more"><button class="mx-link" type="button" data-act="copy">Copy link to this design</button><a class="mx-link" href="' + esc(D.text.appointment || '/pages/visit-us') + '">Book an appointment</a></div>';
    h += '<ul class="mx-rb-notes"><li>' + esc(D.text.sourcing) + '</li><li>' + esc(D.text.visit) + ' <a href="tel:' + esc(D.text.phoneE164) + '" data-hm-where="ring-builder">' + esc(D.text.phone) + '</a></li></ul>';
    h += '</div></div>';
    view.innerHTML = h;
  }

  function renderSummary() {
    var s = settingByHandle(S.setting), v = settingVariant(s, S.metal), d = S.diamondChosen || S.step === 'diamond' ? diamond() : null;
    var total = (v && s ? v.price : 0) + (d && S.diamondChosen ? d.price : 0);
    var next = !s ? null : !S.diamondChosen ? (S.step === 'diamond' ? ['choose-diamond', 'Choose this diamond'] : ['go-diamond', 'Choose a diamond']) : S.step !== 'review' ? ['go-review', 'Review your ring'] : null;
    var art = ringSVG({ metal: v ? v.metal : S.metal, shape: d ? d.shape : S.shape, style: s ? s.style : 'Solitaire', carat: d ? d.carat : (S.carat || 1), label: 'Your ring so far' });
    var h = '<div class="mx-rb-sum__art">' + art + '</div><h2 class="mx-rb-sum__h">Your ring</h2>';
    h += '<div class="mx-rb-sum__row"><span>' + (s ? esc(s.title) + '<small>' + esc(v.metal) + '</small>' : '<em class="mx-muted">Setting not chosen</em>') + '</span><span class="mx-num">' + (s ? fmtMoney(v.price) : '—') + '</span></div>';
    h += '<div class="mx-rb-sum__row"><span>' + (d && S.diamondChosen ? esc(caratLabel(d.carat) + ' ' + cap(d.shape)) + '<small>' + esc((d.origin ? originLabel(d.origin) + ' · ' : '') + d.color + ' · ' + d.clarity) + '</small>' : '<em class="mx-muted">Diamond not chosen</em>') + '</span><span class="mx-num">' + (d && S.diamondChosen ? fmtMoney(d.price) : '—') + '</span></div>';
    h += '<div class="mx-rb-sum__total"><span>Total</span><span class="mx-num">' + (total ? fmtMoney(total) : '—') + '</span></div>';
    if (next) h += '<button class="mx-btn mx-btn--block" type="button" data-act="' + next[0] + '">' + next[1] + '</button>';
    h += '<p class="mx-rb-sum__help">Questions? <a href="tel:' + esc(D.text.phoneE164) + '" data-hm-where="ring-builder">' + esc(D.text.phone) + '</a></p>';
    summary.innerHTML = h;

    var b = '<div class="mx-rb-bar__art">' + art + '</div><div class="mx-rb-bar__t"><span class="mx-small mx-muted">' + (s ? esc(s.title) : 'Your ring') + '</span><strong class="mx-num">' + (total ? fmtMoney(total) : 'Start designing') + '</strong></div>';
    if (next) b += '<button class="mx-btn mx-btn--sm" type="button" data-act="' + next[0] + '">' + next[1].replace('Choose this diamond', 'Choose diamond').replace('Review your ring', 'Review') + '</button>';
    else if (S.step === 'review' && s && S.diamondChosen) b += '<button class="mx-btn mx-btn--sm" type="button" data-act="scroll-add">Finish</button>';
    bar.innerHTML = b;
  }

  function renderSteps() {
    var s = settingByHandle(S.setting), v = settingVariant(s, S.metal), d = S.diamondChosen ? diamond() : null;
    root.querySelectorAll('[data-step]').forEach(function (a) {
      var st = a.getAttribute('data-step');
      var done = st === 'setting' ? !!s : st === 'diamond' ? !!d : false;
      a.classList.toggle('is-current', S.step === st);
      a.classList.toggle('is-done', done);
      if (S.step === st) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
    });
    root.querySelector('[data-rb-step-pick="setting"]').textContent = s ? s.title + ' · ' + fmtMoney(v.price) : 'Choose a setting';
    root.querySelector('[data-rb-step-pick="diamond"]').textContent = d ? caratLabel(d.carat) + ' ' + cap(d.shape) + ' · ' + fmtMoney(d.price) : 'Choose a diamond';
    root.querySelector('[data-rb-step-pick="review"]').textContent = s && d ? fmtMoney(v.price + d.price) : 'Review & finish';
  }

  function render(scroll) {
    fixDiamond();
    if (S.step === 'setting') renderSetting();
    else if (S.step === 'diamond') renderDiamond();
    else renderReview();
    renderSummary();
    renderSteps();
    save();
    if (scroll) {
      var top = root.querySelector('.mx-rb__steps').getBoundingClientRect().top + scrollY - 140;
      if (scrollY > top + 40) scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function go(step) { if (location.hash !== '#/' + step) location.hash = '#/' + step; else { S.step = step; render(true); } }
  function fromHash() {
    var m = /#\/(setting|diamond|review)/.exec(location.hash);
    S.step = m ? m[1] : (S.setting ? (S.diamondChosen ? 'review' : 'diamond') : 'setting');
  }
  window.addEventListener('hashchange', function () { fromHash(); render(true); });

  /* ---------- Detail dialog --------------------------------------------- */
  var detail = root.querySelector('[data-rb-detail-dialog]');
  function openDetail(handle) {
    var s = settingByHandle(handle);
    if (!s || !detail) return;
    var v = settingVariant(s, S.metal);
    var img = (v && v.image) || s.images[0];
    detail.innerHTML = '<div class="mx-rb-detail"><div class="mx-rb-detail__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(s.title) + '">' : ringSVG({ metal: v.metal, shape: S.shape, style: s.style, carat: S.carat || 1, label: s.title })) +
      (s.images.length > 1 ? '<div class="mx-rb-review__thumbs">' + s.images.slice(0, 4).map(function (i) { return '<img src="' + esc(i) + '" alt="" loading="lazy">'; }).join('') + '</div>' : '') + '</div>' +
      '<div class="mx-rb-detail__body"><div class="mx-rb__dialog-head"><span class="mx-kicker">' + esc(s.style) + '</span><button class="mx-icon-btn" type="button" data-rb-close aria-label="Close"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.3"><path d="m6 6 12 12M18 6 6 18"/></svg></button></div>' +
      '<h2 class="mx-h2">' + esc(s.title) + '</h2><p class="mx-rb-stone__price mx-num">' + fmtMoney(v.price) + ' <small class="mx-muted">setting only</small></p>' +
      (s.text ? '<p class="mx-lede">' + esc(s.text) + '</p>' : '') +
      '<div class="mx-rb-metals" role="group" aria-label="Metal"><span class="mx-label">Metal</span>' + metalsOf(s).map(function (m) {
        return '<button class="mx-rb-metal" type="button" data-act="detail-metal" data-h="' + esc(s.handle) + '" data-v="' + esc(m) + '" aria-pressed="' + (v.metal === m) + '" title="' + esc(m) + '">' + swatch(m) + '<span>' + esc(karat(m)) + '</span><span class="mx-sr">' + esc(m) + '</span></button>';
      }).join('') + '<span class="mx-rb-metal__name">' + esc(v.metal) + '</span></div>' +
      '<button class="mx-btn mx-btn--block" type="button" data-act="choose-setting" data-h="' + esc(s.handle) + '">Choose this setting · ' + fmtMoney(v.price) + '</button>' +
      (s.url ? '<a class="mx-link" href="' + esc(s.url) + '" style="margin-top:14px">Full details</a>' : '') + '</div></div>';
    if (!detail.open) detail.showModal();
  }

  /* ---------- Cart ------------------------------------------------------- */
  function buildId() { return 'R' + Date.now().toString(36).toUpperCase(); }
  function addToCart(btn) {
    var s = settingByHandle(S.setting), v = settingVariant(s, S.metal), d = diamond();
    var err = root.querySelector('[data-rb-err]');
    if (!S.size) { err.textContent = 'Please choose a ring size, or pick “I’ll be sized in the store”.'; root.querySelector('#rb-size').focus(); return; }
    err.textContent = '';
    var id = buildId();
    var center = diamondLine(d);
    var setProps = { 'Center diamond': center, 'Ring size': S.size, '_build': id };
    if (S.engraving) setProps['Engraving'] = S.engraving;
    var dProps = { 'Shape': cap(d.shape), 'For ring': s.title + ' · ' + v.metal, '_build': id };
    btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: 1, properties: setProps }, { id: d.id, quantity: 1, properties: dProps }] };
    if (drawer) { body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = location.pathname; }
    fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.disabled = false; btn.textContent = label;
        if (!res.ok || res.j.status) { err.textContent = (res.j && (res.j.description || res.j.message)) || 'Something went wrong. Please call us.'; return; }
        try { if (window.MX && window.MX.track) window.MX.track('ring_builder_add_to_cart', { value: (v.price + d.price) / 100 }); } catch (e) {}
        if (drawer && res.j.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res.j); }
        else location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; err.textContent = 'Couldn’t reach the store. Check your connection and try again.'; });
  }

  /* ---------- Ask dialog ------------------------------------------------- */
  var ask = root.querySelector('[data-rb-ask-dialog]');
  function openAsk() {
    var s = settingByHandle(S.setting), v = settingVariant(s, S.metal), d = S.diamondChosen ? diamond() : null;
    var lines = [];
    if (s) lines.push('Setting: ' + s.title + ' (' + s.style + '), ' + v.metal + ' — ' + fmtMoney(v.price));
    if (d) lines.push('Center diamond: ' + diamondLine(d) + ' — ' + fmtMoney(d.price));
    if (s && d) lines.push('Total: ' + fmtMoney(v.price + d.price));
    if (S.size) lines.push('Ring size: ' + S.size);
    if (S.engraving) lines.push('Engraving: ' + S.engraving);
    var text = lines.join('\n') || 'No selections yet';
    ask.querySelector('[data-rb-ask-design]').value = text;
    ask.querySelector('[data-rb-ask-link]').value = location.href;
    ask.querySelector('[data-rb-ask-preview]').innerHTML = esc(text).replace(/\n/g, '<br>');
    var f = ask.querySelector('form');
    if (f && f.action.indexOf('#') < 0) f.action = f.action.split('#')[0];
    ask.showModal();
  }

  /* ---------- Events ----------------------------------------------------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act], [data-rb-close]');
    if (!t) return;
    if (t.hasAttribute('data-rb-close')) { var dl = t.closest('dialog'); if (dl) dl.close(); return; }
    var act = t.getAttribute('data-act'), v = t.getAttribute('data-v'), h = t.getAttribute('data-h');
    switch (act) {
      case 'style': S.style = v; render(); break;
      case 'metal': S.metal = v; render(); break;
      case 'detail': openDetail(h); break;
      case 'detail-metal': S.metal = v; openDetail(h); render(); break;
      case 'choose-setting':
        S.setting = h;
        var cs = settingByHandle(h);
        if (cs && metalsOf(cs).indexOf(S.metal) < 0) S.metal = metalsOf(cs)[0];
        if (detail && detail.open) detail.close();
        go(S.diamondChosen ? 'review' : 'diamond'); break;
      case 'tab': S.tab = v; render(); break;
      case 'origin': S.origin = v; S.stock = null; render(); break;
      case 'shape': S.shape = v; S.stock = null; render(); break;
      case 'spec': S[t.getAttribute('data-k')] = v; S.stock = null; render(); break;
      case 'choose-diamond': S.stock = null; S.diamondChosen = true; go(S.setting ? 'review' : 'setting'); break;
      case 'choose-stock': S.stock = v; S.diamondChosen = true; var st = stockById(v); if (st && SHAPES.indexOf(st.shape) > -1) S.shape = st.shape; go(S.setting ? 'review' : 'setting'); break;
      case 'go-diamond': go('diamond'); break;
      case 'go-review': go('review'); break;
      case 'add': addToCart(t); break;
      case 'ask': openAsk(); break;
      case 'scroll-add': var b = root.querySelector('[data-act="add"], [data-act="ask"]'); if (b) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); } break;
      case 'copy':
        var done = function () { t.textContent = 'Link copied'; setTimeout(function () { t.textContent = 'Copy link to this design'; }, 2400); };
        if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(done, done); else done();
        break;
    }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-act="size"]')) { S.size = e.target.value; var err = root.querySelector('[data-rb-err]'); if (err) err.textContent = ''; }
  });
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-act="engraving"]')) S.engraving = e.target.value.slice(0, 20);
  });
  root.querySelectorAll('dialog').forEach(function (dl) {
    dl.addEventListener('click', function (e) { if (e.target === dl) dl.close(); });
  });

  fromHash();
  render();
})();
